/*
 *   File : otp-input.js
 *   Author : https://evoqins.com
 *   Description : OTP input component
 *   Integrations : NA
 *   Version : 1.0.0
*/

//custom style
import { useEffect, forwardRef, memo, useState, useRef } from "react";

//Style
import style from "../../Style/Component/input.module.scss";

const OTPInput = forwardRef((props, ref) => {

    const [pin, setPin] = useState(props.value);
    const otpLabelInputRef = useRef(null);
    const [inputWidth, setInputWidth] = useState(0);

    useEffect(() => {
        setPin(props.value);
    }, [props.value]);

    useEffect(() => {
        setInputWidth(otpLabelInputRef.current.clientWidth);
    }, [otpLabelInputRef.current]);

    useEffect(() => {

        if (ref && props.focusedInput === 2 && props.value.length <= 4) {
            ref.current.focus();
        };

    }, [props.focusedInput]);

    // handle otp change
    const _handleOtpChange = (event) => {
        const value = event.target.value;
        const allowed_values = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", ""];
        if (allowed_values.includes(value.slice(-1)) === false) return;
        setPin(value);
        props.onChange(value);

    };

    // const _preventDefaults = (e) => {
    //     const key_code = e.keyCode || e.which;
    //     const is_ctrl_pressed = e.ctrlKey || e.metaKey; // Check if Ctrl key is pressed

    //     if (e.keyCode === 13) {
    //         props.onKeyPress();
    //     }

    //     if (key_code === 9 || // Tab key
    //         (is_ctrl_pressed && (key_code === 65 || key_code === 67 || key_code === 88 || key_code === 86))
    //     ) {
    //         // Ctrl+A, Ctrl+C, Ctrl+X, or Ctrl+V    
    //         e.preventDefault();
    //     }

    //     if (
    //         (key_code >= 48 && key_code <= 57) || // 0-9
    //         (key_code >= 96 && key_code <= 105) || // Numpad 0-9
    //         key_code === 8 || // Backspace
    //         (key_code >= 37 && key_code <= 40) // Arrow keys
    //     ) {
    //         // Allow the keypress
    //     } else {
    //         e.preventDefault();
    //     }
    // };


    const _preventDefaults = (e) => {
        const key_code = e.keyCode || e.which;

        if (key_code === 13) {
            props.onKeyPress();
        }


        if (
            (key_code >= 48 && key_code <= 57) || // 0-9
            (key_code >= 96 && key_code <= 105) || // Numpad 0-9
            key_code === 8 || // Backspace
            (key_code >= 37 && key_code <= 40) // Arrow keys
        ) {
            // allow
        } else {
            // Don't block anything else, or at most:
            // e.preventDefault(); <-- REMOVE this line to allow paste
        }
    };
    return (
        <div className={props.wrapperClass}>
            {props.label &&
                <label className={`${props.labelStyle} e-text-chinese-black e-font-14 e-primary-font e-font-weight-400 line-height-18px padding-4px-bottom`}>
                    {props.label}
                    {props.required &&
                        <span className='e-text-carmine-pink'>*</span>
                    }
                </label>
            }
            <div className={`${style.e_otp_wrapper} position-relative d-flex flex-column align-items-start user-select-none`}>
                <input
                    style={{ width: inputWidth + "px" }}
                    type="text"
                    ref={ref}
                    maxLength={4}
                    id={props.id}
                    value={pin}
                    spellCheck={props.spellCheck}
                    className={`mb-0 e-caret-color-transparent`}
                    onFocus={props.onFocus}
                    onBlur={props.onBlur}
                    autoComplete="off"
                    autoFocus={props.autoFocus}
                    tabIndex={props.tabIndex}
                    onChange={_handleOtpChange}
                    onKeyDown={_preventDefaults} />

                <label ref={otpLabelInputRef} className='d-flex gap-2 align-items-center' onClick={props.onFocus}>
                    <div className={`align-items-center justify-content-center w-48px h-48px e-font-weight-500 e-font-16 line-height-20px d-inline-flex e-primary-font ${props.focusedInput === 2 ? style.e_active : style.e_inactive}`}>
                        {pin.length !== 0 ?
                            <span className="padding-6px-top e-text-chinese-black">*</span> :
                            <span className="pt-2"></span>
                        }
                    </div>
                    <div className={`align-items-center justify-content-center w-48px h-48px e-font-weight-500 e-primary-font e-font-16 line-height-20px d-inline-flex
                 ${props.focusedInput === 2 && pin.length >= 2 ? style.e_active : style.e_inactive}`}>
                        {pin.length >= 2 ?
                            <span className="padding-6px-top e-text-chinese-black">*</span> :
                            <span className={`pt-2`}></span>
                        }
                    </div>
                    <div className={`align-items-center justify-content-center w-48px h-48px e-font-weight-500 e-primary-font e-font-16 line-height-20px d-inline-flex
                 ${props.focusedInput === 2 && pin.length >= 3 ? style.e_active : style.e_inactive}`}>
                        {pin.length >= 3 ?
                            <span className="padding-6px-top e-text-chinese-black">*</span> :
                            <span className={`pt-2`}></span>
                        }
                    </div>
                    <div className={`align-items-center justify-content-center w-48px h-48px e-font-weight-500 e-primary-font e-font-16 line-height-20px d-inline-flex 
                ${props.focusedInput === 2 && pin.length >= 4 ? style.e_active : style.e_inactive}`}>
                        {pin.length >= 4 ?
                            <span className="padding-6px-top e-text-chinese-black">*</span> :
                            <span className={`pt-2`}></span>
                        }
                    </div>
                </label>

                {props.error &&
                    <p className={`position-absolute bottom--16px mb-0 e-text-carmine-pink e-primary-font e-font-12 line-height-12px pt-1 e-font-weight-500`}>
                        {props.error}
                    </p>
                }
            </div>
        </div>
    )
});

OTPInput.defaultProps = {
    onKeyPress: () => { },
    className: null,
    error: "",
}

export default memo(OTPInput);